
import React, {Component} from 'react';
import {connect} from 'react-redux'
import { Button, Form, FormGroup, ControlLabel } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import FontAwesome from 'react-fontawesome';
// import './report.css';
import Moment from 'moment';
import ReportStore from 'stores/ReportStore';
import IframeModal from 'component/element/IframeModal'
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import PrintButtons from 'component/element/PrintButtons'
import DatePicker from 'component/element/DatePicker'
import { Radio } from 'react-icheck'
import ProductQuickView from '../../stock/ProductQuickView';
const YEAR = (Moment(new Date()).format("YYYY")*1)+543
const START_DATE = '01/01/'+YEAR
const END_DATE = '01/12/'+YEAR
var MobileDetect = require('mobile-detect')
const localKey = 'report.stocklistinout'
class ReportStockListInOut extends Component {

  constructor(props){
    super(props)
    
    const optionsRows = [10,20,50,100]
    let md = new MobileDetect(window.navigator.userAgent);
    let sliptable_page = ''
    let title_destop = ''
    if(md.is('iOS') || md.is("AndroidOS")){ 
      sliptable_page = 'sliptable-page iv-olview'
      title_destop = ''
    } else { 
      sliptable_page = 'sliptable-page-destop iv-olview'
      title_destop = 'title-destop'
    }  

    let startDate = new Moment(new Moment().format("01/MM/YYYY"),"DD/MM/YYYY");
    let endDate  = new Moment().endOf('month');
    this.state = {
      title_destop:title_destop,
      sliptable_page:sliptable_page,
      data:[],
      displayTb:'',
      displayBar:'none',
      btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;{this.props.messages['View Bar Chart']}</div>),
      btnAction:'barchart',  
      loading:false,
      totalPage:0,
      activePage:1,
      report_title:this.props.messages['Fetching']+'..',
      defaultRows:20,
      optionsRows:optionsRows,
      dataExcel:[],
      start_date:startDate.format("DD/MM/")+YEAR,
      end_date:endDate.format("DD/MM/")+YEAR,
      type_price: JSON.parse(localStorage.getItem(localKey)) || 'unit',
      overlayStyle:{width:0},
      overlayProduct:null,
      isOpenQuickProduct:false,
    }  
    this.barChart = null
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&this.props.show!==newProps.show) {
      this.loadReportStockListInOut()
    }
  }

  loadReportStockListInOut(start_date=START_DATE, end_date=END_DATE) {
    this.setState({loading:true})

    let day_start = start_date.substring(0,2)
    let month_start = start_date.substring(3,5)
    let year_start = (start_date.substring(6,10)*1)-543
    let en_start = day_start+'/'+month_start+'/'+year_start
    let day_end = end_date.substring(0,2)
    let month_end = end_date.substring(3,5)
    let year_end = (end_date.substring(6,10)*1)-543
    let en_end = day_end+'/'+month_end+'/'+year_end
    
    ReportStore.loadReportStockListInOut(en_start,en_end,(result)=>{
        this.setState({dataExcel:result.data,data:result.data,loading:false,report_title:this.props.messages['Data Not Found']})
        if (this.props.typePrint==='chart')
            this.setBarChart(en_start,en_end)
        else 
            this.setBarChart(en_start,en_end)
    })
  }

  setBarChart(start_date=START_DATE, end_date=END_DATE) {
    let {messages} = this.props
    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let ctxBar = this.ctxBar
    let {data} = this.state
    let cost_amount = 0
    data.forEach((item,index)=>{
        cost_amount += this.getValid(item.cost_amount)
    })
    let sale_amount = 0
    data.forEach((item,index)=>{
        sale_amount += this.getValid(item.sale_amount)
    })

    let datasets = [{label:messages['PO price'],backgroundColor:'#d9534f',data:[cost_amount]},{label:messages['Sale price'],backgroundColor:'#00a65a',data:[sale_amount]}]
    
    if (this.barChart!==null) {
        this.barChart.destroy()
    }
    this.barChart = new Chart(ctxBar, {
        type: 'bar',
        data: {
            labels: [messages['PO-Sale price']],
            datasets: datasets
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        padding: 0
                    }
                }]
            },
            // legend: legend
        }
    })
  }

  getValid(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    return _val
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getTextMonth(month) {
    let {messages} = this.props

    return month==='01'||month==='1' ? messages['January'] : month==='02'||month==='2' ? messages['February'] : month==='03'||month==='3' ? messages['March'] : month==='04'||month==='4' ? messages['April'] : month==='05'||month==='5' ? messages['May'] : month==='06'||month==='6' ? messages['June'] : month==='07'||month==='7' ? messages['July'] : month==='08'||month==='8' ? messages['August'] : month==='09'||month==='9' ? messages['September'] : month==='10' ? messages['October'] : month==='11' ? messages['November'] : month==='12' ? messages['December'] : ''
  }

  onDateChange(key,date) {
    let {start_date,end_date} = this.state
    if (key==='start_date')
        start_date = date
    else
        end_date = date     
    
    this.setState({start_date:start_date,end_date:end_date})   
    this.loadReportStockListInOut(start_date,end_date) 
  }

  onPrintClick() {
    let {start_date,end_date,type_price} = this.state
    let type_print = 'report'
    if (this.state.displayBar==='')
      type_print = 'chart'
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url  = './?startPage=PrintReportStockListInOut&start_date='+start_date+"&end_date="+end_date+"&type_print="+type_print+"&type_price="+type_price
    } else{
      url = './pdf/v2/?startPage=PrintReportStockListInOut&start_date='+start_date+"&end_date="+end_date+"&type_print="+type_print+"&type_price="+type_price
    }
    this.refs.iframe.loadUrl(url)    
  }

  onBarChartClick(action) {
    let new_action = ""
    if (action==="barchart") {
      new_action = "report"
      this.setState({btnAction:new_action,displayTb:'none',displayBar:'',btnBar:(<div><FontAwesome name='file-text'/>&nbsp;{this.props.messages['View Report']}</div>)})
      this.loadReportStockListInOut(this.state.start_date,this.state.end_date)
      this.setBarChart(this.state.start_date,this.state.end_date)
    } else {
      new_action = "barchart"
      this.setState({btnAction:new_action,displayTb:'',displayBar:'none',btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;{this.props.messages['View Bar Chart']}</div>)})
      this.loadReportStockListInOut(this.state.start_date,this.state.end_date)
    }
  }

  onExportExcel() {
    let {messages} = this.props
    let {start_date,end_date} = this.state
    const worksheet = XLSX.utils.table_to_book(document.getElementById('report-stocklist-inout'));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    let fileName = messages['Stock List In Out Report']+' '+start_date+' '+messages['To']+' '+end_date+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
  }

  onPriceTypeClick(value) {
    let reportStockConfig = value
    localStorage.setItem(localKey, JSON.stringify(reportStockConfig))
    this.setState({type_price:value})
  }

  renderRowData() {
    let {messages} = this.props
    let {data,type_price} = this.state
    if (data.length===0) {
        return(<tr><td colSpan={type_price===''?11:9}>{messages['Data Not Found']}</td></tr>)
    } else {
        return(
            data.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center' onMouseOver={this.onOpenNav.bind(this,item)} onMouseLeave={this.onCloseNav.bind(this)}>{item.productcode}</td>
                        <td onMouseOver={this.onOpenNav.bind(this,item)} onMouseLeave={this.onCloseNav.bind(this)}>{item.detail}</td>
                        <td className='text-center'>{item.in_quantity}</td>
                        <td className='text-center'>{item.out_quantity}</td>
                        <td className='text-center'>{item.balance_quantity}</td>
                        {type_price==='unit'||type_price===''?<td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>:''}
                        {type_price==='total'||type_price===''?<td className='text-right'>{this.getNumberFormat(item.cost_amount)}</td>:''}
                        {type_price==='unit'||type_price===''?<td className='text-right'>{this.getNumberFormat(item.sale_per_unit)}</td>:''}
                        {type_price==='total'||type_price===''?<td className='text-right'>{this.getNumberFormat(item.sale_amount)}</td>:''}
                        <td>{item.remark}</td>
                    </tr>        
                )
            })
        )
    }
  }

  getDate() {
    let {start_date,end_date} = this.state
    return this.props.messages['Daily']+' '+start_date+' - '+end_date 
  }

  getSummary(field) {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      let val = (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
      sum += val
    })
    return sum
  }

  renderTable() {
    let {messages} = this.props
    let {type_price} = this.state
    return(
      <div className="table-responsive report-stocklist-inout">
        <table id='report-stocklist-inout' className="table table-hover table-bordered">
          <thead>
            <tr style={{display:'none'}}>
              <th className='text-center' colSpan={type_price===''?11:9}>{this.props.messages['Stock List In Out Report']} {this.getDate()}</th>
            </tr>
            <tr>
              <th rowSpan={2} style={{width:"5%"}} className="text-center">{messages['Number']}</th>
              <th rowSpan={2} style={{width:"10%"}} className="text-center">{messages['Product Number']}</th>
              <th rowSpan={2} style={{width:"25%"}} className="text-center">{messages['Product List']}</th>
              <th colSpan={3} className="text-center">{messages['Quantity']}</th>
              <th colSpan={type_price===''?4:2} className="text-center">{messages['Price']}</th>
              <th rowSpan={2} style={{width:"20%"}} className="text-center">{messages['Remark']}</th>
            </tr>
            <tr>
              <th style={{width:"8%"}} className='text-center'>{messages['In']}</th>
              <th style={{width:"8%"}} className='text-center'>{messages['Out']}</th>
              <th style={{width:"8%"}} className='text-center'>{messages['Balance']}</th>
              {type_price==='unit'||type_price===''?<th style={{width:"8%"}} className='text-center'>{messages['Buy']}</th>:''}
              {type_price==='total'||type_price===''?<th style={{width:"8%"}} className='text-center'>{messages['Total Buy']}</th>:''}
              {type_price==='unit'||type_price===''?<th style={{width:"8%"}} className='text-center'>{messages['Sale']}</th>:''}
              {type_price==='total'||type_price===''?<th style={{width:"8%"}} className='text-center'>{messages['Total Sale']}</th>:''}
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={3}></th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('in_quantity'))}</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('out_quantity'))}</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('balance_quantity'))}</th>
              {type_price==='total'
              ?
              [<th key={'t-0'} className='text-right'>{this.getNumberFormat(this.getSummary('cost_amount'))}</th>,
              <th key={'t-1'} className='text-right'>{this.getNumberFormat(this.getSummary('sale_amount'))}</th>,
              <th key={'t-2'} className='text-center'></th>]
              :type_price==='unit'
              ?
              <th colSpan={3}></th>
              :
              [<th key={'a-0'} className='text-right' colSpan={2}>{this.getNumberFormat(this.getSummary('cost_amount'))}</th>,
              <th key={'a-1'} className='text-right' colSpan={2}>{this.getNumberFormat(this.getSummary('sale_amount'))}</th>,
              <th key={'a-2'} className='text-center'></th>]}
            </tr>
          </tfoot>
        </table>
      </div>
    )
  } 

  renderTitle(){
    if (this.props.reportPage === true) {
      return this.props.renderMenu()
    } else {
      return (
        <div style={{display:'inline'}}>{this.props.messages['Income Report']}</div>                       
      )
    }
  }

  renderBarChat() {
    return(
      <div>
        <canvas 
          ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}>
        </canvas>
      </div>
    )
  }

  renderBarChatTitle() {
    return this.props.messages['Stock List In Out Report Table']
  }

  renderBarChatSubTitle() {
      return this.props.messages['Start']+' '+this.state.start_date+' '+this.props.messages['To']+' '+this.state.end_date
  }

//   renderRowDataExcel() {
//     let {messages} = this.props
//     let {dataExcel} = this.state
//     if (dataExcel.length===0) {
//       return(<tr><td colSpan={7}>{messages['Data Not Found']}</td></tr>)
//     } else {
//       return(
//         dataExcel.map((item,index)=> {
//           return(
//             <tr key={index}>
//               <td className="text-center">{item.doc_date}</td>
//               <td className="text-center">{item.doc_no}</td>
//               <td>{item.customer_name}</td>
//               <td className="text-center">{item.car_registration_no}</td>
//               <td className="text-right">{this.getNumberFormat(item.amount)}</td>
//               <td className="text-right">{this.getNumberFormat(item.vat)}</td>
//               <td className="text-right">{this.getNumberFormat(item.grand_amount)}</td>
//             </tr>
//           )
//         })
//       )
//     }
//   }

//   renderTableExcel() {
//     let {messages} = this.props
//     return(
//       <div className="display-overflow" style={{display:'none'}}>
//         <table id='report-income' className="table table-responsive table-bordered-solid table-hover table-report-income">
//           <thead>
//             <tr>
//               <th style={{width:"90px"}} className="text-center">{messages['Date']}</th>
//               <th style={{width:"90px"}} className="text-center">{messages['Receipt Number']}</th>
//               <th style={{width:"300px"}}>{messages['Customer']}</th>
//               <th style={{width:"90px"}} className="text-center">{messages['Car Registration']}</th>
//               <th style={{width:"90px"}} className="text-right">{messages['Total Value']}</th>
//               <th style={{width:"90px"}} className="text-right">{messages['Tax']}</th>
//               <th style={{width:"90px"}} className="text-right">{messages['Total']}</th>
//             </tr>
//           </thead>
//           <tbody>
//             {this.renderRowDataExcel()}
//           </tbody>
//         </table>
//       </div>      
//     )
//   }

  onOpenNav(item) {
    this.setState({isOpenQuickProduct:true},()=>{
      if(this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
      this.hoverTimer = setTimeout(()=>{         
        const overlayStyle = { width: 500 };    
        this.setState({ overlayStyle, overlayProduct: item });            
      },500)
    })  
  }

  onCloseNav() {
    this.setState({isOpenQuickProduct:false},()=>{
      if(this.hoverTimer) {
        clearTimeout(this.hoverTimer);
          this.hoverTimer = null;
      }
      this.hoverTimer = setTimeout(()=>{   
        const overlayStyle = { width: 0 };
        this.setState({ overlayStyle,overlayProduct:null });
      },500)
    })  
  }

  renderOverlayProduct(){
    let {isOpenQuickProduct,overlayProduct} = this.state
    if(isOpenQuickProduct ){
      if(overlayProduct!=null){
        return (            
          <ProductQuickView show={overlayProduct!=null} itemnum={overlayProduct.itemnum}  onClose={this.onCloseNav.bind(this)}/>            
        )
      }else{
        return (<div className="product-overlay" style={{width:300}}>
          {this.props.messages['Can use the mouse to scroll through the list immediately']}...
        </div>)
      }
    }else{
      return ('')
    }
  }

  render(){
    let {messages} = this.props
    let {data,type_price} = this.state

    if (this.props.showPrintPreview !== true) {
      return (
        <div>
            <Box loading={this.state.loading}>
                <Box.Header border={true}>
                  {this.props.renderMenu()}
                </Box.Header>
                <Box.Body>
                <Form inline style={{marginBottom:'5px'}}>
                    <FormGroup
                        validationState={null}
                    >
                    <ControlLabel>{messages['Start']} :</ControlLabel>
                    <DatePicker
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={this.state.start_date} 
                        onChange={this.onDateChange.bind(this,'start_date')}
                        maxWidth={'100%'}
                        inline={false}
                    />         
                    </FormGroup>
                    {' '}
                    <FormGroup
                        validationState={null}
                    >
                    <ControlLabel>{messages['To']} :</ControlLabel>
                    <DatePicker
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={this.state.end_date} 
                        onChange={this.onDateChange.bind(this,'end_date')}
                        maxWidth={'100%'}
                        inline={false}
                    />         
                    </FormGroup>
                    {' '}
                    <span className='form-date-responsive'>
                      <FormGroup className='mg-b--25-md'>
                        <ControlLabel style={{display:'block'}} className='display-md'><br /></ControlLabel>
                        <Button                 
                          className='bg-maroon'
                          onClick={this.onPrintClick.bind(this)}
                        >
                          <FontAwesome name='print'/>&nbsp;{messages['Print Document']}
                        </Button>  
                      </FormGroup>
                      &nbsp;
                      <FormGroup className='mg-b--25-md'>
                        <ControlLabel style={{display:'block'}} className='display-md'><br /></ControlLabel>
                        <Button
                          className='btn-primary'
                          onClick={this.onBarChartClick.bind(this,this.state.btnAction)}
                        >
                          {this.state.btnBar}
                        </Button>   
                      </FormGroup>
                    </span>  
                    {' '}
                    <FormGroup 
                      style={{display:this.state.displayTb}}
                    >
                      <ControlLabel className='display-md'><br /></ControlLabel>
                      <PrintButtons
                            width={''}
                            display={''}
                            marginLeft={''}
                            onExportExcel={this.onExportExcel.bind(this)}
                      />   
                    </FormGroup>
                    {' '}
                    <FormGroup style={{marginTop:'25px'}}>
                      <Radio
                        onChange={this.onPriceTypeClick.bind(this,'unit')}
                        checked={type_price==='unit'}
                        radioClass="iradio_square-blue"
                        increaseArea="20%"
                        label={' '+messages['Price/Unit']}
                      />
                      {' '}
                      <Radio
                        onChange={this.onPriceTypeClick.bind(this,'total')}
                        checked={type_price==='total'}
                        radioClass="iradio_square-blue"
                        increaseArea="20%"
                        label={' '+messages['Total price']}
                      />
                      {' '}
                      <Radio
                        onChange={this.onPriceTypeClick.bind(this,'')}
                        checked={type_price===''}
                        radioClass="iradio_square-blue"
                        increaseArea="20%"
                        label={' '+messages['Both']}
                      />
                    </FormGroup>
                </Form>
                <div style={{display:this.state.displayTb}}>
                    {this.renderTable()}
                    {/*this.renderTableExcel()*/}
                    {/*<div className="text-right">
                      <Form inline>
                        <FormGroup>
                        {messages['Number Of Rows Per Page']}
                        </FormGroup>  
                        {' '}
                        <FormGroup>
                        <DropdownButton bsStyle={'default'} title={this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)}>
                            {this.state.optionsRows.map((item,index)=>(
                            <MenuItem key={index} eventKey={item}>{item}</MenuItem>  
                            ))}
                        </DropdownButton>
                        </FormGroup> 
                        {' '} 
                        <FormGroup style={{lineHeight:'10px'}}>
                        <Pagination
                            prev={messages['Previous']}
                            next={messages['Next']}
                            first={false}
                            last={false}
                            ellipsis
                            boundaryLinks
                            items={this.state.totalPage}
                            maxButtons={5}
                            activePage={this.state.activePage}
                            onSelect={this.handleSelect.bind(this)}
                        />
                        </FormGroup>  
                      </Form>  
                    </div>*/}
                </div> 
                <div style={{display:this.state.displayBar}}>
                    {this.renderBarChat()}
                </div>  
                <IframeModal ref='iframe' title={messages['Print Document']}/>
                </Box.Body>
            </Box>
            {this.renderOverlayProduct()}
        </div>
      )
    } else {
      if (this.props.typePrint==='chart') {
        if (data.length===0) {
          return(
            // <div className='a4-onlineview landscape'>
            //   <div className={this.state.sliptable_page+' landscape font-print'}>
            //     <div className="no-of-page">
            //       <span><br/></span>
            //     </div>
            //     <header className="align-center">
            //       <h2 className={this.state.title_destop}>{this.state.report_title}</h2>
            //     </header>
            //   </div>                      
            // </div>
            <div className='font-print'>
              <header className="text-center">
                <h2>{this.state.report_title}</h2>
              </header>
            </div> 
          )
        } else {
          return(
            // <div className='a4-onlineview landscape report-stocklist-inout'>
            //   <div className={this.state.sliptable_page+' landscape font-print'}>
            //     <div className="no-of-page">
            //       <span><br/></span>
            //     </div>
            //     <header className="align-center">
            //       <h2 className={this.state.title_destop}>{this.renderBarChatTitle()}<p className='sub-title' style={{fontSize:'20px'}}>{this.renderBarChatSubTitle()}</p></h2>
            //     </header>
            //     <div>
            //       {this.renderBarChat()}
            //     </div>
            //   </div>                      
            // </div>
            <div className='font-print'>
              <header className="text-center">
                <h2>
                  {this.renderBarChatTitle()}<p className='sub-title' style={{fontSize:'20px'}}>{this.renderBarChatSubTitle()}</p>
                </h2>
              </header>
              <div>
                {this.renderBarChat()}
              </div>
            </div> 
          )
        }  
      }
    }  
  }
}

export default ReportStockListInOut = connect(
  (state) => ({messages: state.message.view.report.ReportStockListInOut}),null,null,{withRef:true}
)(ReportStockListInOut);



// WEBPACK FOOTER //
// ./src/view/report/stock/ReportStockListInOut.js